/**
 * Javascripot source for ACS Time Critical contact form
 */
acsContact = function($) {

	var transitionSpeed = 300;

    var init = function() {
	    var $form = $('#acs-contact-form');
    		
    	//when the form has been submitted
		$form.submit(function(e) {
			e.preventDefault();
			
console.log('form submitted');
			if (!$form.hasClass('loading')) {
				$form.addClass('loading');
				$form.find('.error').remove();
			  	
				//create formData object from form
				var formData = new FormData($form[0]);
		
		        grecaptcha.ready(function() {
		            grecaptcha.execute('6LcT7IMeAAAAABgsh8I3tAaZWdVavhafITqT8pt0', {action: 'submit'}).then(function(token) {
console.log('adding recaptcha data to form');
						//append new elements for recaptcha
						formData.append("token", token);
		                submitForm($form, formData);
		            });;
		        });
			  	
		  	}
		});
    };

    var submitForm = function($form, formData) {
		$.ajax({
			method: "POST",
			data: formData,
			processData: false,
			contentType: false,
  		    url: ajax_url,//set in the footer
			cache: false,
		}).done(function( data ) {
			//do we have a valid response?
  			  if (typeof data.result != 'undefined') {
  				  if (data.result=='error') {
	  				  //append any error messages
	  				  if (typeof data.errors != 'undefined') {
	  					  $.each(data.errors, function(key, val) {
	  					    //find the field with the matching name				  					    
	  						$form.find('input[name="'+key+'"], select[name="'+key+'"], textarea[name="'+key+'"]').first().parents('.form__input, .form-field').append('<span class="error">'+val+'</span>');
	  					  });
	  				  }
  				  } else if (data.result=='success') {
  					  //registered ok
					  sendAnalyticsEvent();
  				  } else if (data.result=='captcha') {
					$form.replaceWith('<p class="error">Security checks failed, please try again later</p>');
  				  }	
  			  } else {
  				//catch all error
  				$form.replaceWith('<p class="error">Received an error from the server, please try again later</p>');
  			  }
		}).fail(function(jqXHR, textStatus, errorThrown) {
			console.log('got an error when submitting form');
			console.log( jqXHR );
			console.log( textStatus );
			$form.replaceWith('<p class="error">Received an error from the server. Please try again later</p>');
		}).always(function() {
			//remove loading class from form
			$form.removeClass('loading');
		});
    };

    /*
     * send an event to google analytics
     */
    var sendAnalyticsEvent = function() {
	
		addToDataLayer();
	
    	var eventLabel = "ACS Time Critical Enquiry";

    	if (typeof gtag != "undefined") {
		  gtag('event', 'enquiry', {
			'event_category': 'enquiry',
			'event_label': eventLabel,
		    'event_callback': function() {
		      redirect();
		    }
		  });
		} else {
			redirect();
		}
    };

    /*
     * Add to GTM data layer
     */
    var addToDataLayer = function() {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event' 	  : 'enquiry',
			'service' 	  : $('select[name="service"]').val(),
            'schedule'	  : $('select[name="schedule"]').val(),
            'departing'   : $('input[name="departing"]').val(),
            'destination' : $('input[name="destination"]').val(),
            'notes'	  	  : $('textarea[name="additional"]').val(),
            'name'		  : $('input[name="yourname"]').val(),
            'company'	  : $('input[name="company"]').val(),
            'email'		  : $('input[name="email"]').val(),
            'country'	  : $('select[name="country"]').val(),
            'phone'		  : $('select[name="phonecountrycode"]').val()+$('input[name="phone"]').val()
		});
    };

    /*
     * Redirect to thankyou page
     */
    var redirect = function() {
		window.location.href = '/contact/thank-you/';
    };
    
    return{init:init}//return items that are available outside

}(jQuery);


//document ready
jQuery(function() {
	acsContact.init();
});